export default "__VITE_ASSET__CrwJvkcO__"